import { render, staticRenderFns } from "./SurveyStatisticsExamples.vue?vue&type=template&id=22a5e162"
import script from "./SurveyStatisticsExamples.ts?vue&type=script&lang=ts&external"
export * from "./SurveyStatisticsExamples.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports